import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'

import i18n from 'src/plugins/i18n'

export async function createEmptyDrawTemplate () {
  const fields = ['round', 'blue', 'green', 'yellow', 'red', 'variability']
  const numberRounds = 100
  const workbook = new ExcelJS.Workbook()
  const sheet = workbook.addWorksheet('rounds')

  // Header
  sheet.addRow(fields.map(field => i18n.t(`multiproject.fields.draw.${field}`)))

  // Rounds
  const roundRows = new Array(numberRounds)
    .fill(null)
    .map((item, index) => ([index + 1]))
  sheet.addRows(roundRows)

  // Write workbook file
  const data = await workbook.xlsx.writeBuffer()
  const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
  FileSaver.saveAs(blob, 'multiproject-draw-template.xlsx')
}

function extractSheetRows ({ sheet, from, to }) {
  const rows = []
  sheet.eachRow((row, index) => index >= from && index <= to && rows.push(row))
  return rows
}

export async function readRoundListFromExcel (file) {
  return new Promise((resolve, reject) => {
    const wb = new ExcelJS.Workbook()
    const reader = new FileReader()

    reader.onerror = reject
    reader.onload = async () => {
      try {
        const buffer = reader.result
        const workbook = await wb.xlsx.load(buffer)
        const sheet = workbook.getWorksheet(1)
        const rows = extractSheetRows({ sheet, from: 2, to: 101 })
        resolve(rows.map((row, index) => ({
          orderNumber: index + 1,
          blue: row.getCell(2).value,
          green: row.getCell(3).value,
          yellow: row.getCell(4).value,
          red: row.getCell(5).value,
          variability: row.getCell(6).value,
        })))
      }
      catch (error) {
        reject(error)
      }
    }

    reader.readAsArrayBuffer(file)
  })
}
